// import banner from "../../assets/images/srilankatelecom_cover.png";
// import UserDetails from "../userDetails/UserDetails";
// import Box from "@mui/material/Box";

// const Header = () => {
//   return (
//     <Box
//       sx={{
//         display: "flex",
//         width: "100%",
//         background: `linear-gradient(to right,rgb(229, 243, 255),rgb(222, 238, 252))`,
//       }}
//     >
//       <Box
//         sx={{
//           flex: 4,
//           margin: 2,
//           marginLeft: 6,
//         }}
//       >
//         {/* Left column */}
//         <img
//           src={banner}
//           alt="Banner"
//           style={{
//             width: "100%",
//             height: "auto",
//             maxWidth: "1000px",
//             maxHeight: "180px",
//             borderRadius: "20px",
//           }}
//         />
//       </Box>
//       <Box
//         sx={{
//           flex: 2,
//         }}
//       >
//         {/* Left column */}
//         <UserDetails />
//       </Box>
//     </Box>
//   );
// };

// export default Header;
import banner from "../../assets/images/web.jpg";
import UserDetails from "../userDetails/UserDetails";
import Box from "@mui/material/Box";
import styled from "styled-components";

const ResponsiveBanner = styled.img`
  width: 100%;
  height: auto;
  max-width: 750px;
  border-radius: 20px;
  object-fit: cover;

  @media (max-width: 500px) {
    max-height: 120px;
  }

  @media (max-width: 300px) {
    max-height: 80px;
    border-radius: 10px;
  }
`;

const Header = () => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "minmax(0px, 2fr) minmax(0px, 1fr)",
        width: "100%",
        background: `linear-gradient(to right,rgb(229, 243, 255),rgb(222, 238, 252))`,
        gap: "0px",
        alignItems: "center",
        // padding: 1,
      }}
    >
      <Box
        sx={{
          margin: 2,
          marginLeft: { xs: 2, md: 6 },
          width: "100%",
          maxWidth: "750px",
          "@media (max-width: 1370px)": {
            maxWidth: "600px",
          },
          "@media (max-width: 1344px)": {
            maxWidth: "600px",
          },
          "@media (max-width: 1100px)": {
            maxWidth: "400px",
          },

          "@media (max-width: 900px)": {
            maxWidth: "300px",
          },
        }}
      >
        <ResponsiveBanner src={banner} alt="Banner" />
      </Box>
      <Box
        sx={{
          justifySelf: "end",
          paddingRight: { xs: "20px", md: "40px" },
          width: "100%",
          maxWidth: "350px",
        }}
      >
        <UserDetails />
      </Box>
    </Box>
  );
};

export default Header;
